import { Cliente } from "./Cliente";

export class Endereco {

    constructor() {
        this.cep = '';
        this.logradouro = '';
        this.numero = '';
        this.bairro = '';
        this.complemento = '';
        this.cidade = '';
        this.estado = '';
        this.cep = '';
    }

    public id: number;
    public logradouro: string;
    public numero: string;
    public bairro: string;
    public complemento: string;
    public cidade: string;
    public estado: string;
    public cep: string;
    public cliente: Cliente;
}